//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var BASE_URL = '/prototype/accounting/accounts-receivable/transactions';

export default {
    data: function data() {
        return {
            item: {},
            person: {},
            property: {},
            lease: {},
            transactions: [],
            recurringItems: [],
            deposit_amount: 0,
            balance: 0,
            move_in_date: moment().format('MM/DD/YY')
        };
    },
    created: function created() {
        Event.$on('move-out-ledger', this.moveOutLedger);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('move-out-ledger');
    },

    methods: {
        moveOutLedger: function moveOutLedger(item) {
            var $el = this;
            $el.item = item;
            console.log(item);
            $el.person = item.person;
            $el.property = item.property;
            $el.lease = item.lease;
            $el.$children[0].$data.showSmallModal = true;
            $el.deposit_amount = item.unit.unit_lease.resident_deposit_amount;
            $el.move_in_date = moment($el.item.move_in_date).format("MM/DD/YYYY");

            axios.post('/prototype/resident/ledger/balance', { id: item.id }).then(function (response) {
                return $el.balance = response.data;
            });
            axios.post('/prototype/resident/ledger', { id: item.id }).then(function (response) {
                if (response.data) {
                    $el.loading = false;
                    $el.transactions = response.data.transactions;
                }
            });
            axios.post(BASE_URL + '/resident/recurring', { id: $el.person.id }).then(function (response) {
                $el.recurringItems = response.data;
            });
        },

        moveOut: function moveOut() {
            var $el = this;
            axios.post('/prototype/email-statement', { id: this.item.id }).then(function (response) {
                if (response.data.code && response.data.code == 219) {
                    var notify = response.data.msg ? response.data.msg : '';
                    $el.$snotify.error(notify);
                } else {
                    Event.$emit('close-small-modal');
                    Event.$emit('past-resident-list-updated');
                    $el.$snotify.success('The account settlement is send');
                }
            });
        },
        print: function print() {
            // Pass the element id here
            this.$htmlToPaper('printMe');
        }
    },
    computed: {
        finalAmount: function finalAmount() {
            var $el = this;
            return Number.parseFloat($el.deposit_amount - $el.balance);
        },
        finalAmountReceivable: function finalAmountReceivable() {
            var $el = this;
            return Math.abs(Number.parseFloat($el.deposit_amount - $el.balance));
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/past-residents/MoveOutLedger.vue
// module id = Jlwb
// module chunks = 0 1